import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createSlots as _createSlots, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8082c830"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container component-survey-page" }
const _hoisted_2 = {
  key: 0,
  class: "main"
}
const _hoisted_3 = { class: "text-box" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = ["innerHTML"]

import { reactive, ref, computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { request, getQuestions, getAnswers, alert } from '@/utils';
  import { FormItem  } from '@/types/form';
  import { Responses  } from '@/types/responses';

  interface IProps {
    slug: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    slug: null
  },
  setup(__props: any) {

const props = __props as {
    slug: string;
  }

  

  const { t } = useI18n();

  const formList = ref<FormItem[]>([]);
  const survey = ref();
  async function fetchData() {
    const { data } = await request.get(`/surveys/${props.slug}`);
    survey.value = data;
    formList.value = getQuestions(data);
    formList.value.push({
      label: t('CAPTCHA'),
      type: 'custom',
      required: true,
      placeholder: t('Captcha'),
      key: 'g_recaptcha_response',
      inputType: 'text',
    });
  }

  const routes = computed(() => {
    return [
      {
        name: t('Home'), to: { name: 'home' },
      },
      {
        name: survey.value?.title
      }
    ];
  });

  const form = reactive({
    g_recaptcha_response: ''
  });
  function formItemChange(data: any) {
    form[data.key] = data.value;
  }

  async function handleSubmit() {
    const answers = getAnswers(form, formList.value);
    // 移除验证码answer
    answers.pop();
    const body: Responses = {
      survey_id: Number(survey.value.id),
      type: 'SpecifyResponse',
      answers_attributes: answers,
      g_recaptcha_response: form.g_recaptcha_response
    };
    try {
      await request.post('responses', body);
      alert({ title: t('Success'), content: t('Operation success'), });
      Object.keys(form).forEach(key => {
        form[key] = null;
      });
    } finally {
      form.g_recaptcha_response = '';
    }
  }

  fetchData();

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!
  const _component_GoogleRecaptcha = _resolveComponent("GoogleRecaptcha")!
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcurmb, { routes: _unref(routes) }, null, 8, ["routes"]),
    (survey.value?.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(survey.value.title), 1),
            _createElementVNode("div", {
              class: "desc",
              innerHTML: survey.value.desc
            }, null, 8, _hoisted_5)
          ]),
          _createVNode(_component_b_form, {
            class: "form-box",
            onSubmit: handleSubmit
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.key,
                  class: "form-group-item"
                }, [
                  _createVNode(_component_AppFormGroupItem, {
                    config: item,
                    form: _unref(form),
                    onChange: formItemChange
                  }, _createSlots({ _: 2 }, [
                    (item.key === 'g_recaptcha_response')
                      ? {
                          name: "custom",
                          fn: _withCtx(() => [
                            _createVNode(_component_GoogleRecaptcha, {
                              modelValue: _unref(form)['g_recaptcha_response'],
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form)['g_recaptcha_response']) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        }
                      : undefined
                  ]), 1032, ["config", "form"])
                ]))
              }), 128)),
              _createVNode(_component_b_button, {
                type: "submit",
                class: "submit-btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Submission')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})